var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStripe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#stripe_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#635BFF",
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.44 15.55c0-.94.77-1.31 2.05-1.31 1.84 0 4.16.56 6 1.55v-5.68C24.48 9.31 22.5 9 20.5 9c-4.91 0-8.17 2.56-8.17 6.84 0 6.67 9.19 5.61 9.19 8.49 0 1.11-.97 1.47-2.32 1.47-2.01 0-4.57-.82-6.6-1.93v5.75c2.25.97 4.52 1.38 6.6 1.38 5.03 0 8.49-2.49 8.49-6.82-.04-7.2-9.25-5.92-9.25-8.63"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "stripe_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#fff",
  rx: 20
})))));
export default SvgStripe;